import Immutable from 'immutable';
import {
    subscribeToBetbookAuthor as subscribeToBetbookAuthorApi,
    unsubscribeFromBetbookAuthor as unsubscribeFromBetbookAuthorApi
} from './nike-notification-server-api';

export const setMatchNotificationTypes = (eventId, data) => db =>
    db.setIn(['notifications', 'types', 'match', eventId], Immutable.fromJS(data));

export const subscribeToBetbookAuthor = authorNickname => db => {
    // optimistic UI
    subscribeToBetbookAuthorApi(authorNickname).catch(console.log);
    const data = { analysesTracking: true, blogsTracking: true, ticketsTracking: true };
    return db.setIn(['notifications', 'betbook', authorNickname], Immutable.fromJS(data));
};

export const unsubscribeFromBetbookAuthor = authorNickname => db => {
    // optimistic UI
    unsubscribeFromBetbookAuthorApi(authorNickname).catch(console.log);
    return db.deleteIn(['notifications', 'betbook', authorNickname]);
};
